import { UserManager, WebStorageStateStore } from 'oidc-client';

export const authConfig = {
    ...(window.env.REACT_APP_AUTHORITY && { authority: window.env.REACT_APP_AUTHORITY }),// Replace with your issuer URL
    ...(window.env.REACT_APP_CLIENT_ID && {client_id: window.env.REACT_APP_CLIENT_ID}),
    ...(window.env.REACT_APP_CLIENT_SECRET && {client_secret: window.env.REACT_APP_CLIENT_SECRET}), // Replace with your client id
    redirect_uri: window.env.REACT_APP_REDIRECT_UI,
    response_type: window.env.REACT_APP_RESPONSE_TYPE,
    ...(window.env.REACT_APP_SCOPE && {scope: window.env.REACT_APP_SCOPE}),
    post_logout_redirect_uri: window.env.REACT_APP_POST_LOGOUT_REDIRECT_UI,
    ...(window.env.REACT_APP_USERINFO_ENDPOINT && {userinfo_endpoint: window.env.REACT_APP_USERINFO_ENDPOINT}), // Replace with your user-info endpoint
    response_mode: window.env.REACT_APP_RESPONSE_MODE,
    code_challenge_method: window.env.REACT_APP_CODE_CHALLENGE_METHOD,
    automaticSilentRenew: window.env.REACT_APP_AUTOMATIC_SILENT_RENEW
}
export const UserManagerInstance = new UserManager({
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    ...authConfig,
    response_mode: 'query'
})